import { theme, type ThemeConfig } from 'antd';
import { colors, typography, radius } from './tokens';

// antd ConfigProvider theme. Maps our design tokens onto antd's token system
// so default antd components render in the AgentStudio look automatically.
export const antdLightTheme: ThemeConfig = {
  algorithm: theme.defaultAlgorithm,
  token: {
    colorPrimary: colors.ink[600],
    colorSuccess: colors.green[600],
    colorWarning: colors.amber[600],
    colorError: colors.red[600],
    colorInfo: colors.violet[600],
    colorBgBase: colors.slate[50],
    colorBgContainer: '#FFFFFF',
    colorBgLayout: colors.slate[50],
    colorTextBase: colors.slate[900],
    colorBorder: colors.slate[200],
    colorBorderSecondary: colors.slate[100],
    fontFamily: typography.fontUi,
    fontFamilyCode: typography.fontMono,
    borderRadius: radius.md,
    borderRadiusLG: radius.lg,
    borderRadiusSM: radius.sm,
    wireframe: false,
  },
  components: {
    Button: { borderRadius: radius.md, fontWeight: 500 },
    Card: { borderRadiusLG: radius.lg, paddingLG: 20, boxShadowTertiary: '0 1px 3px rgba(15,23,42,0.06)' },
    Table: { headerBg: colors.slate[50], rowHoverBg: colors.ink[50] },
    Tag: { borderRadiusSM: radius.full },
    Menu: { itemBorderRadius: radius.md },
    Layout: { siderBg: '#FFFFFF', headerBg: '#FFFFFF' },
  },
};

export const antdDarkTheme: ThemeConfig = {
  algorithm: theme.darkAlgorithm,
  token: {
    ...antdLightTheme.token,
    colorBgBase: colors.slate[900],
    colorBgContainer: colors.slate[800],
    colorBgLayout: colors.slate[900],
    colorTextBase: colors.slate[50],
    colorBorder: colors.slate[700],
    colorBorderSecondary: colors.slate[800],
  },
  // Component overrides must be re-declared per-mode — re-using the light
  // map would force `headerBg: slate[50]` (a near-white) onto dark tables,
  // leaving header text invisible. Same story for Layout sider/header.
  components: {
    Button: { borderRadius: radius.md, fontWeight: 500 },
    Card: {
      borderRadiusLG: radius.lg,
      paddingLG: 20,
      boxShadowTertiary: '0 1px 3px rgba(0,0,0,0.4)',
    },
    Table: {
      headerBg: colors.slate[800],
      headerColor: colors.slate[100],
      headerSplitColor: colors.slate[700],
      rowHoverBg: colors.slate[700],
      borderColor: colors.slate[700],
    },
    Tag: { borderRadiusSM: radius.full },
    Menu: { itemBorderRadius: radius.md },
    Layout: { siderBg: colors.slate[900], headerBg: colors.slate[900] },
  },
};
